export const POST = 'POST';
export const CAROUSEL = 'CAROUSEL';
export const VIDEO = 'VIDEO';
export const REEL = 'REEL';
